import { cn } from "@/lib/utils"
import { User, Sparkles } from "lucide-react"

export function AiMessage({ role, content, isStreaming }) {
  const isUser = role === "user"

  return (
    <div className={cn("flex gap-3", isUser && "flex-row-reverse")}>
      <div
        className={cn(
          "flex h-7 w-7 shrink-0 items-center justify-center rounded-full",
          isUser ? "bg-zinc-200 text-zinc-700" : "bg-kf-red/10 text-kf-red"
        )}
      >
        {isUser ? <User className="h-4 w-4" /> : <Sparkles className="h-4 w-4" />}
      </div>
      <div
        className={cn(
          "rounded-lg px-3 py-2 text-sm max-w-[85%]",
          isUser
            ? "bg-zinc-100 text-zinc-900"
            : "bg-white border border-zinc-200 text-zinc-800"
        )}
      >
        <div className="whitespace-pre-wrap break-words">
          {content}
          {isStreaming && (
            <span className="inline-block w-1.5 h-4 bg-kf-red/60 animate-pulse ml-0.5 align-middle" />
          )}
        </div>
      </div>
    </div>
  )
}
